import React, { useEffect } from "react";
import { Form, Input, Modal } from "antd";
import { Close } from "@mui/icons-material";

const InsertHtmlModal = ({ preview, previewHandler, submitHandler }) => {
  // CONST VALS
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [preview]);

  return (
    <Modal
      visible={preview}
      centered
      className="add-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Insert HTML Into Editor</h2>
      <p>Enter HTML content below</p>
      <Form form={form} onFinish={submitHandler}>
        <label htmlFor="html">HTML</label>
        <Form.Item name="html">
          <Input.TextArea rows={10} placeholder="Enter HTML content" />
        </Form.Item>
        <div className="action-box">
          <button type="button" onClick={previewHandler}>
            Cancel
          </button>
          <button className="submit" type="submit">
            Submit HTML
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default InsertHtmlModal;
